import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const updateUserById = async (data, id) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/update/${id}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateUserById- error", error)
        return handleApiError(error)
    }
}

export const updateUserStatusById = async (id, statusId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/update-status/${id}`, statusId);
        return await response.data;
    } catch (error) {
        console.log("updateUserStatusById- error", error)
        return handleApiError(error)
    }
}

export const getUserRolesByCompanyId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/user-roles/company`, data)
        return await response.data
    } catch (error) {
        console.log("getUserRolesByCompanyId- error", error)
        return handleApiError(error)
    }
}

export const insertUserRole = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/user-roles/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertUserRole- error", error)
        return handleApiError(error)
    }
}

export const searchUsers = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchUserRoles- error", error)
        return handleApiError(error)
    }
}

export const searchUserRoles = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/user-roles/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchUserRoles- error", error)
        return handleApiError(error)
    }
}

export const getUserRoles = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/user-roles/`, data);
        return await response.data;
    } catch (error) {
        console.log("getUserRoles- error", error)
        return handleApiError(error)
    }
}

export const getUserRoleById = async (data) => {
    try {
        const { userRoleId } = data
        const response = await axios.post(`${REACT_APP_API_URL}/user-roles/${userRoleId}`, data);
        return await response.data;
    } catch (error) {
        console.log("getUserRoleById- error", error)
        return handleApiError(error)
    }
}

export const insertBulkUserRoles  = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/user-roles/create/bulk`, data);
        return await response.data;
    } catch (error) {
        console.log("insertBulkUserRoles- error", error)
        return handleApiError(error)
    }
}

export const getUserById  = async (userId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/${userId}`);
        return await response.data;
    } catch (error) {
        console.log("getUserById- error", error)
        return handleApiError(error)
    }
}

export const getBuyerDetailsBybuyerReqId = async (buyerReqId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/users/buyer-req/${buyerReqId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerDetailsBybuyerReqId- error", error)
        return handleApiError(error)
    }
}

export const getUsers = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/`, data);
        return await response.data;
    } catch (error) {
        console.log("getUsers- error", error)
        return handleApiError(error)
    }
}

export const getClientSuccessManagers  = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/user-roles/client-success-managers`);
        return await response.data;
    } catch (error) {
        console.log("getClientSuccessManagers- error", error)
        return handleApiError(error)
    }
}

export const getBuyerCompaniesUsers  = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/users/buyer-company-users`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerCompaniesUsers- error", error)
        return handleApiError(error)
    }
}

export const companyUserRoleValidation  = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/user-roles/company-user-role-validation`, data);
        return await response.data;
    } catch (error) {
        console.log("companyUserRoleValidation- error", error)
        return handleApiError(error)
    }
}

export const getBuyerReqKamsByBranchIds  = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/users/buyer-req/kams`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerReqKamsByBranchIds- error", error)
        return handleApiError(error)
    }
}